import React from 'react'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { useStaticQuery, graphql } from 'gatsby'
import Img, { FluidObject } from 'gatsby-image'
import { Container } from 'components/Container'
import { backgroundColors, colors } from 'styles/colors'
import { IconList } from 'components/IconList'
import { displayWidth } from 'styles/width'
import { mobileAfterBorder } from 'styles/mobileAfterBorder'
import { Title } from 'components/TitleComponent'
import { getDataByLanguage } from 'utils/getDataByLanguage'
import { getImageByImageName } from 'utils/getImageByImageName'
import { imagesDataProp } from 'types/interfaces'
import { LeftSidebar, RightSidebar } from 'components/SideBar'

const VisualizationAdvantagesWrapper = styled.div`
    display: flex;
    justify-content: center;
    width: 100%;
    background-color: ${backgroundColors.vizualization};
    position: relative;
    @media (min-width: ${displayWidth.tablet}) {
        border-bottom: 1px solid ${colors.dark};
    }
    ${mobileAfterBorder}
`
const IconListStyled = styled(IconList)`
    border-bottom: 1px solid ${colors.dark};
    @media (min-width: ${displayWidth.tablet}) {
        border-bottom: none;
    }
`

const Image = styled(Img)<{ fluid: FluidObject }>`
    width: 100%;
    height: auto;
    color: transparent;
`
const HeroColumn = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    border-bottom: 1px solid ${colors.dark};
    @media (min-width: ${displayWidth.tablet}) {
        border-bottom: none;
        border-right: 1px solid #231f20;
    }
`

export const VisualizationAdvantages = ({
    imagesData,
}: {
    imagesData: imagesDataProp
}) => {
    const { i18n } = useTranslation()
    const data = useStaticQuery(graphql`
        query {
            allVisualizationAdvantagesYaml {
                edges {
                    node {
                        title
                        items {
                            content
                            svg
                        }
                        parent {
                            ... on File {
                                name
                            }
                        }
                    }
                }
            }
        }
    `)
    const projectStructureData = getDataByLanguage(
        data.allVisualizationAdvantagesYaml,
        i18n.language
    )
    const { title, items } = projectStructureData
    const imageFluid = getImageByImageName(imagesData, 'carpet.webp')
    return (
        <VisualizationAdvantagesWrapper>
            <LeftSidebar background={backgroundColors.vizualization} />
            <Container columns={'1fr'} tabletColumns={'1fr 2fr'}>
                <HeroColumn>
                    <Title>{title}</Title>

                    <Image
                        fluid={imageFluid.fluid}
                        loading="eager"
                        alt="carpet image"
                        title="carpet image"
                    />
                </HeroColumn>
                <IconListStyled
                    items={items}
                    fill={backgroundColors.vizualization}
                />
            </Container>
            <RightSidebar />
        </VisualizationAdvantagesWrapper>
    )
}
